
import React from 'react';

const BrandingSolution = () => {
  return (
    <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-gray-900 py-16 px-4 rounded-lg shadow-xl">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl font-bold mb-4">Complete Branding Solutions</h1>
        <h2 className="text-2xl font-semibold mb-6">Craft a Powerful Brand Identity That Stands Out</h2>
        <p className="text-lg mb-8">
          Your brand is more than just a logo—it's the emotions, values, and message that connect you with your audience. 
          A strong brand identity builds trust, sets you apart from competitors, and creates a lasting impression.
        </p>
      </div>
    </div>
  );
};

export default BrandingSolution;